
import user from "./user";
import app from "./app";
import music from "./music";
export default {
    user,
    app,
    music
};

